import dayjs from 'dayjs';
import 'dayjs/locale/ja';

export default defineNuxtPlugin((nuxtApp) => {
  dayjs.locale('ja');
  nuxtApp.provide('dayjs', dayjs);
});
